import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  CSVService,
  FieldMapperType,
  MultiFieldMapper,
} from '../../service/csv.service';
import { ReplaySubject, Subscription } from 'rxjs';
import { DownloadService } from '../../service/download.service';
import { GymReportDownload } from '../../model/csv-download-models/gym-report-donwload';
import { BaseDirective, LoggerService } from '@egym/ngx-adm-int';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LeadReportService } from '../../service/lead-report.service';
import { ReportProgress } from '../../model/csv-download-models/report-progress';

@Component({
  selector: 'gymfinder-gym-report',
  templateUrl: './gym-report.component.html',
  styleUrls: ['./gym-report.component.scss'],
  standalone: false,
})
export class GymReportComponent
  extends BaseDirective<void>
  implements OnInit, OnDestroy
{
  private csvMappings: MultiFieldMapper<GymReportDownload> = {
    id: { mapperType: FieldMapperType.FIELD_EXTRACTOR, fieldChain: ['id'] },
    radius3km: {
      mapperType: FieldMapperType.FIELD_EXTRACTOR,
      fieldChain: ['radius3km'],
    },
    radius5km: {
      mapperType: FieldMapperType.FIELD_EXTRACTOR,
      fieldChain: ['radius5km'],
    },
    radius20km: {
      mapperType: FieldMapperType.FIELD_EXTRACTOR,
      fieldChain: ['radius20km'],
    },
  };

  gymFile: File;
  leadFile: File;
  progressbarValue = 0;
  reportNameValue = undefined;
  hintMessage = '';

  private reportSubscription: Subscription | undefined;
  private progressSubscription: Subscription | undefined;
  private progressSubject = new ReplaySubject<ReportProgress>();

  constructor(
    snackBar: MatSnackBar,
    private csvService: CSVService,
    private downloadService: DownloadService,
    private logger: LoggerService,
    private leadReportService: LeadReportService
  ) {
    super(snackBar);
  }

  ngOnInit(): void {
    this.progressSubscription = this.progressSubject.subscribe(
      ({ message, progress }: ReportProgress) => {
        this.hintMessage = message || '';
        this.progressbarValue = progress || 0;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.reportSubscription) {
      this.reportSubscription.unsubscribe();
      this.reportSubscription = undefined;
    }
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
      this.progressSubscription = undefined;
    }
  }

  public onGymFileChanged(file: File) {
    this.gymFile = file;
    this.canGenerateReport();
  }

  public onLeadFileChanged(file: File) {
    this.leadFile = file;
    this.canGenerateReport();
  }

  public canGenerateReport(): boolean {
    return this.gymFile !== undefined && this.leadFile !== undefined;
  }

  public async generateReport() {
    this.reportSubscription = this.leadReportService
      .generateReport(this.gymFile, this.leadFile, this.progressSubject)
      .subscribe(
        next => {
          const fileContent = this.csvService.convertToCSVWithoutQuotes(
            this.csvMappings,
            next
          );
          const fileName = this.reportNameValue
            ? this.reportNameValue + '.csv'
            : 'gym_report.csv';
          this.downloadService.download(fileContent, fileName, 'text/csv');
          this.hintMessage = 'Done';
        },
        error => {
          this.openSnackBar('There was an error processing the report');
          this.logger.error(error);
        }
      );
  }
}
